import { AwsRum } from 'aws-rum-web';

  const config = {
    sessionSampleRate: parseInt(process.env.REACT_APP_sessionSampleRate, 10),
    guestRoleArn: process.env.REACT_APP_guestRoleArn,
    identityPoolId: process.env.REACT_APP_identityPoolId,
    endpoint: process.env.REACT_APP_endpoint,
    telemetries: process.env.REACT_APP_telemetries.split(','),
    allowCookies: true,
    enableXRay: true
  };

const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID;
const APPLICATION_VERSION = process.env.REACT_APP_APPLICATION_VERSION;
const APPLICATION_REGION = process.env.REACT_APP_APPLICATION_REGION;

  const awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
export default awsRum
